
import { Component, Vue, Watch, Emit, Prop } from "vue-property-decorator";

import { Action } from "vuex-class";

const namespace: string = "user";

@Component
export default class Header extends Vue {
  isOpen = false;

  @Prop({ default: false }) isLoggedIn!: boolean;
  @Prop({ default: undefined }) user: any;

  @Action("updateUser", { namespace }) updateUser: any;

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(newVal: any) {
    this.isOpen = false;
  }

  @Emit() login(): boolean {
    this.isOpen = false;
    return true;
  }

  @Emit() logout(): boolean {
    this.isOpen = false;
    return true;
  }
}
